import { render, staticRenderFns } from "./SearchAll.vue?vue&type=template&id=0fba68ab&scoped=true"
import script from "./SearchAll.vue?vue&type=script&lang=js"
export * from "./SearchAll.vue?vue&type=script&lang=js"
import style0 from "./SearchAll.vue?vue&type=style&index=0&id=0fba68ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba68ab",
  null
  
)

export default component.exports